import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';
import {EntryNote} from 'notebook/util/NoteUtilConstants';

export default class EntryNoteUpdater extends DocumentEvaluationUpdater<EntryNote, EntryNote> {
  getDoc(root: EntryNote): EntryNote {
    return root;
  }

  traverse(evalTraverser: DocumentTraverser, newDoc: EntryNote, oldDoc: EntryNote | null): void {
    evalTraverser.walkEntryNote(newDoc, oldDoc);
  }

  mapDoc(mapper: DocumentMapper, doc: EntryNote): EntryNote {
    return mapper.mapEntryNote(doc, null);
  }

  updatedRoot(root: EntryNote, doc: EntryNote): EntryNote {
    return doc;
  }
}
